export const screenSizes = {
  mobile: 375,
  tablet: 768,
  desktop: 850,
  middleDesktop: 1100,
} as const;
